import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { User } from '../model/User';
import { Observable } from 'rxjs';
import { endpoints } from '../../../../environments/endpoint';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
  })
};

export interface PagedResponse<T> {
  content: T[];
  totalElements: number;
  number: number;
  size: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private http: HttpClient) { }

  public getListUsersProfile(page: number = 0, size: number = 10): Observable<HttpResponse<User[] | PagedResponse<User>>> {
    const params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));

    return this.http.get<User[] | PagedResponse<User>>(endpoints.REST_GTECLOUD_GET_ALL_USERS_PROFILE, {
      ...httpOptions,
      params,
      observe: 'response',
    });
  }

  public saveUserProfile(user: User): Observable<User>{

    return this.http.post<User>(endpoints.REST_GTECLOUD_SAVE_USERS_PROFILE, user, httpOptions);
  }
}
